/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */
'use strict';

module.exports = {
  logBlockedSelectionEvent: function logBlockedSelectionEvent() {
    return null;
  },
  logSelectionStateFailure: function logSelectionStateFailure() {
    return null;
  }
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/draft-js/lib/DraftJsDebugLogging.js
 ** module id = 318
 ** module chunks = 9
 **/